import { render, staticRenderFns } from "./VariableTextArea.vue?vue&type=template&id=369cdc4d&"
import script from "./VariableTextArea.vue?vue&type=script&lang=ts&"
export * from "./VariableTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports